import { WrenchIcon } from "@phosphor-icons/react";
import { type NavigateOptions } from "@tanstack/react-router";
import { useTranslations } from "use-intl";

import PageError from "./PageError";

interface Props {
  backOptions?: NavigateOptions;
}

export const GeneralPageError = ({ backOptions = { to: "/" } }: Props) => {
  const t = useTranslations();

  return (
    <PageError
      subtitles={[t("pageDidntWork")]}
      icon={<WrenchIcon size={60} color="#0212294d" />}
      back={{
        text: t("backToHome"),
        options: backOptions,
      }}
    />
  );
};
